function toDownloadUrl(url) {
    return `${url}?contentDispositon=Attachment`;
}

function toFileNameFromUrl(url) {
    return url.split('/').pop();
}

export { toDownloadUrl, toFileNameFromUrl }